import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetPatientsQuery,
  GetPatientsQueryVariables,
} from "./GetPatients.generated";

const GET_PATIENTS: TypedDocumentNode<
  GetPatientsQuery,
  GetPatientsQueryVariables
> = gql`
  query GetPatients {
    patients {
      name
      lastNameOfOwner
      uuid
      species
      sex
      breed
      age
    }
  }
`;

export default GET_PATIENTS;
